import { AxiosRequestConfig } from 'axios';
import { createEthWalletSignature, getWalletSignatureRequest } from '@utils/signature'
import { toChecksumAddress } from '@utils/string';
import { PublicKey } from '@solana/web3.js'

enum SignedMethods {
  PUT = 'PUT',
  POST = 'POST'
}

const signedEndpoints: string[] = [
  '/update-kyc-status',
]

const signedMethods: SignedMethods[number][] = [
  SignedMethods.POST,
  SignedMethods.PUT
];

const signatureInterceptorCallback = async (config: AxiosRequestConfig) => {
  if (
    signedMethods.includes((config.method as string).toUpperCase()) ||
    signedEndpoints.some(endpoint => config.url?.includes(endpoint))
  ) {
    const createSignature = getWalletSignatureRequest()
    const dataString = JSON.stringify(config.data || config.params);
    const signature = await createSignature(dataString);
    config.headers = {
      ...config.headers,
      Signature: signature
    };
  }

  return config;
}

const walletAddressInterceptor = (config: AxiosRequestConfig) => {
  const walletAddress = config.params?.wallet_address
  const solWalletAddress = config.params?.solana_wallet_address
  if (walletAddress) {
    config.params.wallet_address = toChecksumAddress(walletAddress)
  }
  if (solWalletAddress) {
    config.params.solana_wallet_address = new PublicKey(solWalletAddress).toString()
  }

  return config
}

export {
  signatureInterceptorCallback,
  walletAddressInterceptor
}
